document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.enavi-collection-list__carousel');
  
  if (carousel) {
    const flkty = new Flickity(carousel, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: true,
      pageDots: true,
      wrapAround: false,
      adaptiveHeight: false,
      cellSelector: '.enavi-collection-card-wrapper',
      groupCells: false,
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      }
    }); 


    // Function to update arrow visibility
    function updateArrows() {
      const prevButton = carousel.querySelector('.flickity-prev-next-button.previous');
      const nextButton = carousel.querySelector('.flickity-prev-next-button.next');
      
      if (prevButton) {
        prevButton.style.display = flkty.selectedIndex === 0 ? 'none' : 'block';
      }
      
      if (nextButton) {
        const lastSlide = flkty.slides[flkty.slides.length - 1];
        const lastSlideCell = lastSlide.getCellElements()[0];
        const isLastSlideFullyVisible = !lastSlideCell.classList.contains('enavi-collection-card--grayed');

        nextButton.style.display = isLastSlideFullyVisible ? 'none' : 'block';
      }
    }

    // Function to update cell opacity based on visibility
    function updateCellOpacity() {
      const cells = flkty.getCellElements();
      const carouselRect = carousel.getBoundingClientRect();
      
      cells.forEach(cell => {
        const cellRect = cell.getBoundingClientRect();
        const visibleWidth = Math.min(cellRect.right, carouselRect.right) - Math.max(cellRect.left, carouselRect.left);
        const visiblePercentage = visibleWidth / cellRect.width;
        
        cell.classList.toggle('enavi-collection-card--grayed', visiblePercentage < 0.6); // Gray out when less than 40% visible
      });
    }

    // Adjust cell size for desktop and mobile
    function resizeFlickity() {
      if (window.innerWidth >= 768) {
        flkty.options.groupCells = false;;
      } else {
        flkty.options.groupCells = true;
      }
      flkty.resize();
      updateCellOpacity();
      updateArrows();
    }

    // Adjust position, opacity, and arrows after Flickity's ready event and on scroll
    flkty.on('ready', () => {
      updateCellOpacity();
      updateArrows();
    });
    flkty.on('scroll', () => {
      updateCellOpacity();
      updateArrows();
    });
    flkty.on('select', updateArrows);

    // Initial call and add event listener for window resize
    resizeFlickity();
    window.addEventListener('resize', resizeFlickity);
  }
});
